import { FC } from 'react';

interface VideoProps {
  videoUrl: string;
}

export const Video: FC<VideoProps> = ({ videoUrl }) => {
  // Extract YouTube video ID from a URL (watch, youtu.be, embed, shorts) or a
  // bare 11-character video id.
  const getYouTubeId = (url: string): string | null => {
    const trimmed = url.trim();

    // Already a bare video id.
    if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) {
      return trimmed;
    }

    const regExp =
      /(?:youtu\.be\/|\/v\/|u\/\w\/|\/embed\/|\/shorts\/|watch\?v=|&v=)([a-zA-Z0-9_-]{11})/;
    const match = trimmed.match(regExp);
    return match ? match[1] : null;
  };

  const videoId = getYouTubeId(videoUrl);

  if (!videoId) {
    return null;
  }

  return (
    <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-black">
      <iframe
        src={`https://www.youtube.com/embed/${videoId}?rel=0`}
        title="Course Introduction Video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="absolute top-0 left-0 w-full h-full"
      />
    </div>
  );
};
